
function initAnimation() {
  const box = document.querySelector(".bookmarks__imgs");
  let els = box.querySelectorAll('div');
  els.forEach((el, index) => {
    let x = 0;
    let y = 0;
    let scale = 1;
    let rotate = 0;
    if (index === 3) {
      x = '-50%';
    } else if (index === 0) {
      y = '-50%';
    }
    if (isMobile) {
      if (index === 6) {
        x = '-5%';
        y = '-16%';
      } else if (index === 1) {
        x = '3%';
        y = '-10%';
        scale = .98;
        rotate = '-7deg';
      } else if (index === 3) {
        y = '-50%';
        y = '-15%';
        scale = 1.3;
      } else if (index === 4) {
        y = '-22%';
        x = '6%';
        scale = .98;
        rotate = 0;
      } else if (index === 5) {
        y = '-24%';
        x = '10%';
        rotate = 0;
      } else if (index === 2) {
        y = '-25%';
        x = '7%';
      }
    }
    gsap.to(el,{
      ease: 'none',
      x: x,
      y: y,
      rotate: rotate,
      scale: scale,
      scrollTrigger: {
        trigger: '.section--bookmarks',
        start: isTablet ? 'top bottom' : 'top bottom',
        end: '+=100%',
        scrub: true,
      },
    });
  });

  gsap.fromTo('.bookmarks__imgs', {
    y: isMobile ? 50 : 150
  }, {
    ease: 'none',
    y: 0,
    scrollTrigger: {
      trigger: '.section--bookmarks',
      start: isTablet ? 'top bottom' : 'top bottom',
      end: '+=100%',
      scrub: true,
    },
  });


  const box2 = document.querySelector(".bookmarks-bot__imgs");
  let els2 = box2.querySelectorAll('div');
  const els2Styles = [
    {
      rotate: '-15deg',
      x: '-150%',
    },
    {
      rotate: '-28deg',
      x: '-250%',
      tablet: {
        x: '-50%',
        y: '-0%',
        rotate: '-23deg',
      }
    },
    {
      rotate: '-17deg',
      x: '-200%',
      y: '-19%',
      tablet: {
        x: '-52%',
        y: 0,
      }
    },
    {
      rotate: '-6deg',
      x: '-100%',
      tablet: {
        x: '0%',
        y: '-14%',
        rotate: '-6deg',
      }
    },
    {
      tablet: {
        x: '0%',
        y: '-19%',
        rotate: '0deg',
      }
    },
    {
      rotate: '6deg',
      x: '10%',
      tablet: {
        x: '-65%',
        y: '-6%',
        rotate: '8deg',
      }
    },
    {
      rotate: '13deg',
      x: '50%',
      tablet: {
        x: '-59%',
        y: '-12%',
        rotate: '16deg',
      }
    },
    {
      rotate: '20deg',
      x: '50%',
      tablet: {
        x: '-70%',
        y: '0',
        rotate: '20deg',
      }
    },
    {
      x: '62%',
      y: '-26%',
      rotate: '30deg',
      tablet: {
        x: '-120%',
        y: '-0%',
        rotate: '25deg',
      }
    },
    {
      rotate: '38deg',
      x: '120%',
      tablet: {
      }
    },
  ]
  els2.forEach((el, index) => {
    let rotate = els2Styles[index]?.rotate;
    let x = els2Styles[index]?.x;
    let y = els2Styles[index]?.y ||'-15%';
    if (isTablet) {
      y = els2Styles[index]?.tablet?.y || y;
      x = els2Styles[index]?.tablet?.x || x;
      rotate = els2Styles[index]?.tablet?.rotate || rotate;
    }
    gsap.to(el,{
      ease: 'none',
      rotate: rotate,
      x: x,
      y: y,
      scrollTrigger: {
        trigger: '.bookmarks-bot',
        start: isTablet ? 'top bottom' : 'top bottom',
        end: isMobile ? '+=70%' : '+=100%',
        scrub: true,
      },
    });
  });

  gsap.fromTo('.bookmarks-bot__imgs', {
    y: isMobile ? 50 : 150
  }, {
    ease: 'none',
    y: 0,
    scrollTrigger: {
      trigger: '.bookmarks-bot__imgs',
      start: isTablet ? 'top bottom' : 'top bottom',
      end: isMobile ? '+=70%' : '+=100%',
      scrub: true,
    },
  });
}

document.addEventListener('DOMContentLoaded', initAnimation);